import { useMemo, useState } from 'react';

function useLoadings() {
  const [loadings, setLoadings] = useState({});

  return useMemo(
    () => ({
      resetLoadings: () => setLoadings({}),
      setLoading: (key, loading = true) => setLoadings((prev) => ({ ...prev, [key]: loading })),
      isLoading: (key) => (key in loadings ? loadings[key] : Object.values(loadings).some((loading) => loading)),
    }),
    [loadings],
  );
}

export default useLoadings;
